import React, { useEffect, useMemo, useState } from "react";
import {
    FormBuilder,
} from "../../../utils/FormBuilder/FormBuilder";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormField } from "../../../interfaces/User.interface";
import { Button, CircularProgress, Paper, Typography } from "@mui/material";
import { useMembers } from "../../../contexts/MemberContext";
import { IMember } from "../../../interfaces/Member.interface";
import { useLoading } from "../../../contexts/LoadingContext";
import { FormSection, SimpleFormSection } from "../../../components/Sections";
import { useFetch } from "../../../utils/FetchTemplate";
import { generateValidationSchema } from "../../../utils/FormBuilder/Validators";
import { studentInfoFields, addressInfoFields, permanentReminderField } from "../Fields";
import { Role } from "../../../interfaces/constants";


export const AddNewMemberDialogContent: React.FC<{
    handleFinish: (newMember?: IMember) => void;
    prevData: any;
}> = ({ handleFinish, prevData }) => {
    const [formFields, setFormFields] = useState<FormField[]>([]);
    const { isLoading } = useLoading();
    const { setMembers, fetchMembers} = useMembers();
    const { postData, getData, postDataResponse} = useFetch()
    const [studentFields, setStudentFields] = useState<FormField[]>(studentInfoFields());
    const [addressFields, setAddressFields] = useState<FormField[]>(addressInfoFields());
    const [reminderField, setReminderField] = useState<FormField[]>([permanentReminderField()]);


    useEffect(() => {
        setFormFields([...studentFields, ...addressFields, ...reminderField]);
    }, [studentFields, addressFields, reminderField]);

    const validationSchema = React.useMemo(
        () => generateValidationSchema(formFields),
        [formFields]
    );

    const {
        handleSubmit,
        control,
        watch,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onTouched', // Validate on change
        defaultValues: {
            ...prevData,
        },
    });

    const onSubmit = async (data: any) => {
        const reqBody: Record<string, any> = { ...data };
        if (reqBody.phone) reqBody.phone = reqBody.phone.replace(/\D/g, '');
        const validBody = Object.keys(reqBody).reduce((acc: Record<string, any>, key: string) => {
            if (reqBody[key]) {
                acc[key] = reqBody[key];
            }
            return acc;
        }, {}); // Initialize acc as an empty object
        
        // // 注册 user（调用 signup）
        // const response = await postDataResponse("/api/auth/signup", {
        //     firstName: validBody.firstName,
        //     lastName: validBody.lastName,
        //     email: validBody.email,
        //     password: "woaicaixukun1314", 
        //     role: validBody.role,
        // });
        // const userRes = await response.json();
        // const uid = userRes.user.userId;
        // validBody.uid = uid;
        
        // 创建 member
        const resBody = await postData("/api/member/createMany", [validBody]);
        const newMember = resBody[0] as IMember;
        
        //clean form and get new data
        reset(); 
        await fetchMembers();
        handleFinish(newMember);
    };

    const patitentInfoFormContent = useMemo(() => {
        return FormBuilder(studentFields, control, errors);
    }, [studentFields, control, errors]);

    const addressFormContent = useMemo(() => {
        return FormBuilder(addressFields, control, errors);
    }, [addressFields, control, errors]);

    const permanentReminderFormContent = useMemo(() => {
        return FormBuilder(reminderField, control, errors);
    }, [reminderField, control, errors]);

    const role = watch("role");

    return (
        <form onSubmit={handleSubmit(onSubmit)} id="form" className="space-y-4">
            <FormSection title="Contact">
                {patitentInfoFormContent}
            </FormSection>

            {role !== Role.Teacher && (
                <FormSection title="Address">
                    {addressFormContent}
                </FormSection>
            )}

            <SimpleFormSection title="Note">
                {permanentReminderFormContent}
            </SimpleFormSection>

            <Button
                onClick={handleSubmit(onSubmit)}
                variant="contained"
                color="primary"
                className="w-full"
                disabled={isLoading}
            >
                {isLoading ? <CircularProgress size={24} /> : "Create Member"}
            </Button>
        </form>
    );
};
